// extracted by mini-css-extract-plugin
module.exports = {"grip":"workspace-drag_grip__YqpJb","row":"workspace-drag_row__pDO_c","lifted":"workspace-drag_lifted__n_sQY"};